import React, { useState } from 'react';
import clsx from 'clsx';

import css from './Tabs.module.scss';

export interface TabItem<T = string> {
    title: string;
    value: T | undefined;
    count?: number | null;
}

interface Props<T> {
    tabs: TabItem<T>[];
    defaultSelectedTabId?: number;
    externalSelectedTabId?: number;
    handleClick?: (value: T | undefined) => void;
}

const Tabs = <T = string,>({ tabs, handleClick, defaultSelectedTabId = 0, externalSelectedTabId }: Props<T>) => {
    const [selectedTabId, setSelectedTabId] = useState(externalSelectedTabId ?? defaultSelectedTabId);
    const currentTabId = externalSelectedTabId ?? selectedTabId;

    return (
        <div className={css.container}>
            {tabs.map((tab, idx) => (
                <div
                    className={clsx(css.item, currentTabId === idx && css.active)}
                    key={idx}
                    onClick={() => {
                        setSelectedTabId(idx);
                        if (handleClick) {
                            handleClick(tab.value);
                        }
                    }}
                >
                    {tab.title}
                    <div className={css.counter}>{tab?.count}</div>
                </div>
            ))}
        </div>
    );
};

export default React.memo(Tabs) as typeof Tabs;
